// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__0kS_8","backgroundColor":"Card_backgroundColor___k75s","title":"Card_title__4aidP","row":"Card_row__IhUWB"};